import { LocaleSwitcher } from './index';
import { useLocale } from 'hooks/use-locale';
import type { TenantId } from 'tenants/types/tenant';

type LocaleSwitcherContainerProps = {
  tenantId: TenantId;
  /** Compact treatment for the Area/Search V2 left rail (above the hamburger). */
  variant?: 'default' | 'rail';
};

export function LocaleSwitcherContainer({ tenantId, variant = 'default' }: LocaleSwitcherContainerProps) {
  const { 
    isEnabled, 
    isReady, 
    currentLocale, 
    localeOptions, 
    changeLocale, 
  } = useLocale(tenantId);

  return (
    <LocaleSwitcher
      shouldRender={isEnabled && isReady}
      currentLocale={currentLocale}
      localeOptions={localeOptions}
      changeLocale={changeLocale}
      variant={variant}
    />
  );
} 